import React from 'react'

import { useParams } from 'react-router-dom'

import { useGetMetaAdsCampaignByIdQuery } from 'src/Redux/adsCampaignApi'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import { useGenresAndLanguagesAnalytics } from 'src/Hooks/useGenresAndLanguagesAnalytics'

import { GenreWithoutCurators } from '../components/AdsGenresModalContent/helpers'

type UseSelectedGenresReturnType = {
  selectedGenres: GenreWithoutCurators[]
  onSetSelectedGenres: (genre: GenreWithoutCurators) => void
}

const mapGenresToSelectedGenres = (genres?: string[]): GenreWithoutCurators[] =>
  genres?.map((name) => ({ id: name, genreName: name })) ?? []

export const useSelectedGenres = (): UseSelectedGenresReturnType => {
  const { handlePopupGenreAddedEvent, handlePopupGenreRemovedEvent } =
    useGenresAndLanguagesAnalytics()
  const { number: id } = useParams<{ number: string }>()
  const { data: campaignDetails } = useGetMetaAdsCampaignByIdQuery(Number(id))

  const [selectedGenres, setSelectedGenres] = React.useState<
    GenreWithoutCurators[]
  >(() => mapGenresToSelectedGenres(campaignDetails?.genres))

  React.useEffect(() => {
    setSelectedGenres(mapGenresToSelectedGenres(campaignDetails?.genres))
  }, [campaignDetails?.genres])

  const handleSelectedGenres = (genre: GenreWithoutCurators): void => {
    setSelectedGenres((prev) => {
      const isGenreSelected = prev.some((item) => item.id === genre.id)

      if (isGenreSelected) {
        handlePopupGenreRemovedEvent({
          platformName: CampaignPlatformTypeEnum.META,
          genreName: genre.genreName,
        })

        return prev.filter((item) => item.id !== genre.id)
      }

      handlePopupGenreAddedEvent({
        platformName: CampaignPlatformTypeEnum.META,
        genreName: genre.genreName,
      })

      return [...prev, genre]
    })
  }

  return { selectedGenres, onSetSelectedGenres: handleSelectedGenres }
}
